import React from 'react';

// Temel Modal Stilleri (değişiklik yok)
const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '100px',
    paddingBottom: '20px',
    paddingLeft: '110px',
    paddingRight: '10px',
    overflowY: 'auto',
    zIndex: 9999,
};

const modalContentStyle = {
    background: '#F8F8F8',
    borderRadius: '8px',
    boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
    maxHeight: '85vh',
    width: 'fit-content',
    minWidth: '600px',
    maxWidth: 'calc(100vw - 250px)',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 10000,
    position: 'relative'
};

const modalBodyStyle = {
    overflowY: 'auto', // Kaydırmayı aktif tutar
    padding: '2px'
};

// --- YENİ EKLENEN KISIM ---
// Kaydırma çubuğunu gizlemek için CSS kuralları
const scrollbarHideStyle = `
  .modal-body-no-scrollbar {
    /* Firefox için */
    scrollbar-width: none;
    /* Internet Explorer ve Edge için */
    -ms-overflow-style: none;
  }
  /* Chrome, Safari ve Opera için */
  .modal-body-no-scrollbar::-webkit-scrollbar {
    display: none;
  }
`;
// --- BİTTİ ---

function Modal({ isOpen, onClose, children, minWidth }) {
    if (!isOpen) return null;

    return (
        <div style={modalOverlayStyle}>
            {/* Stilleri bileşene enjekte et */}
            <style>{scrollbarHideStyle}</style>

            <div style={{ ...modalContentStyle, ...(minWidth !== undefined ? { minWidth } : {}) }}>
                {/* --- DEĞİŞİKLİK BURADA --- */}
                {/* Kaydırılabilir alana className ekliyoruz */}
                <div style={modalBodyStyle} className="modal-body-no-scrollbar">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;